var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrongIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9537 30.1321L15.5 19.6818L5.04632 30.1321C4.49297 30.6876 3.74131 31 2.95723 31C2.17315 31 1.42128 30.6876 0.867915 30.1321C0.312353 29.5787 0 28.8269 0 28.0428C0 27.2587 0.312353 26.507 0.867915 25.9537L11.3182 15.5L0.867915 5.04632C0.312353 4.49297 0 3.74131 0 2.95723C0 2.17315 0.312353 1.42128 0.867915 0.867915C1.42126 0.312353 2.17315 0 2.95723 0C3.74131 0 4.49296 0.312353 5.04632 0.867915L15.5 11.3182L25.9537 0.867915C26.507 0.312353 27.2587 0 28.0428 0C28.8269 0 29.5787 0.312353 30.1321 0.867915C30.6876 1.42126 31 2.17315 31 2.95723C31 3.74131 30.6876 4.49296 30.1321 5.04632L19.6818 15.5L30.1321 25.9537C30.6876 26.507 31 27.2587 31 28.0428C31 28.8269 30.6876 29.5787 30.1321 30.1321C29.5787 30.6876 28.8269 31 28.0428 31C27.2587 31 26.507 30.6876 25.9537 30.1321Z",
    fill: "#F97066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongIcon);
export default __webpack_public_path__ + "static/media/WrongIcon.03f19ddd575a6c694f30a73be772940d.svg";
export { ForwardRef as ReactComponent };